// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__YDY7E","greenLine":"Paragraph_greenLine__1fJcR"};